import React from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Button } from "components/common/Button";
import { TextInput } from "components/common/TextInput";

export const SeatStepper: React.FC<{
  id: string;
  seats: number;
  min?: number;
  onChange: (seats: number) => void;
}> = ({ id, seats, min = 1, onChange }) => {
  const clamp = (n: number): number => Math.max(min, n);
  return (
    <span className="flex items-center gap-1">
      <Button
        variant="default"
        size="sm"
        aria-label="One seat fewer"
        disabled={seats <= min}
        onClick={() => onChange(clamp(seats - 1))}
      >
        <RemoveIcon sx={{ fontSize: 14 }} />
      </Button>
      {/* `className` replaces the default, so the base class is restated. */}
      <TextInput
        id={id}
        type="number"
        min={min}
        value={String(seats)}
        onChange={(v) => onChange(clamp(Number(v) || min))}
        className="input-custom h-6 w-12 text-center font-mono number-input-reset"
      />
      <Button
        variant="default"
        size="sm"
        aria-label="One seat more"
        onClick={() => onChange(seats + 1)}
      >
        <AddIcon sx={{ fontSize: 14 }} />
      </Button>
    </span>
  );
};
